module.exports = "/_next/static/images/renewablesWindAndSolar-608eb917b67b13147f4b37578b45a669.webp";